module.exports = __webpack_public_path__ + "img/raider-io.fe68a284.png";